export default __webpack_public_path__ + "static/media/badgeInstaProf.cd394996.svg";